import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Col } from 'react-bootstrap'
import abrcBanner from '../images/abrc-banner.png'

export default class Header extends Component {
  // dark mint: 00B084
  // light mint: 06D6A0
  // orange: F48230
  // grey: D7D6D6
  // brown: 7B3F00

  render () {
    const headerStyle = {
      paddingTop: 22,
      overflow: 'auto'
    }

    const bannerImgStyle = {
      height: '100%',
      width: '100%',
      maxHeight: 224,
      maxWidth: 566
    }

    const subHeaderTextStyle = {
      fontWeight: 'normal',
      // color: '#00B084',
      textAlign: 'left',
      fontFamily: 'Lora',
      lineHeight: '1.3',
      zIndex: 10,
      textShadow: '1px 1px 2px rgba(150, 150, 150, 1)',
      paddingTop: 30
    }

    return (
      <header style={headerStyle}>
        <Col xs={0} sm={1} />
        <Col xs={12} sm={11}>
          <Link to='/'>
            <img
              style={bannerImgStyle}
              src={abrcBanner}
              alt='Americas Best Retirement Calculator'
            />
          </Link>

          <div style={subHeaderTextStyle} className='subHeaderText'>
            The assumptions are critical. Do you know yours?
          </div>
        </Col>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/landing-elements/Header.js